var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 4.70118H0V0.466309H24V4.70118ZM24 8.93606H0V13.1709H24V8.93606ZM24 17.4058H0V21.6407H24V17.4058Z","fill":"black"}));
}

Hamburger.defaultProps = {"width":"24","height":"22","viewBox":"0 0 24 22","fill":"none"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
